import { isEmbroideryTrace } from './appVariant';

// EmbroideryTrace uses durable cloud workers, including localhost previews.
// Explicit overrides still support local workers and Firebase staging projects.
const local = !isEmbroideryTrace && typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);
const root = "https://us-central1-svgtrace-pro.cloudfunctions.net";
export const SATIN_API = (process.env.REACT_APP_SATIN_API ||
  (local ? "http://127.0.0.1:8767" : `${root}/satinApi`)).replace(/\/$/, "");
export const AUTO_DIGITIZE_API = (process.env.REACT_APP_AUTO_DIGITIZE_API ||
  (local ? "http://127.0.0.1:8768" : `${root}/autoDigitizeApi`)).replace(/\/$/, "");
export const CLOUD_SATIN = !/^http:\/\/(localhost|127\.0\.0\.1):8767$/.test(SATIN_API);
